import { startOfDay } from 'date-fns';
import AvailabilityService from '../storefront-client-portal/bundle/components/booking/services/AvailabilityService';

/**
 * Fire-and-forget warm of storefront day appointments so availability is ready
 * while the user is still browsing services, not when they open the time picker.
 */
export const warmStorefrontBusySlotsForDate = (companyId, date = new Date()) => {
  if (!companyId) {
    return Promise.resolve([]);
  }

  return AvailabilityService.fetchDayAppointments(companyId, startOfDay(date)).catch(() => []);
};

export const warmStorefrontBusySlotsForToday = (companyId) =>
  warmStorefrontBusySlotsForDate(companyId, new Date());
